﻿// PRE JS
import 'core-js/stable';
import 'regenerator-runtime/runtime';
import './_Shared/controller';
import './_Shared/outline';

// PRE CSS
import '../Styles/fonts.scss';
import '../Styles/variables.scss';
import '../Styles/mixins.scss';
import '../Styles/functions.scss';
import '../Styles/master.scss';
import '../Styles/episerver.scss';
import '../Styles/forms.scss';
import '../Styles/select.scss';
import '../Styles/fileupload.scss';

// MAIN JS
//import '../../components/pages/bookingflowpage/scripts/bookingflowpage';
//import '../../components/pages/facilitysearchpage/scripts/facilitysearchpage';
import '../../Components/Blocks/CaseContainerBlock/Scripts/CaseContainerBlock';
import '../../Components/Blocks/CollageContainerBlock/Scripts/CollageContainerBlock';
import '../../Components/Blocks/ExpandableListContainerBlock/Scripts/ExpandableListContainerBlock';
import '../../Components/Blocks/ExpandableListContainerBlock/Scripts/ExpandableListContainerBlockExpand';
import '../../Components/Blocks/ExtendedFactsBlock/Scripts/ExtendedFactsBlock';
import '../../Components/Blocks/FacilityInfoBlock/Scripts/facilityInfoBlock';
import '../../Components/Blocks/FacilityUSPBlock/Scripts/FacilityUSPBlock';
import '../../Components/Blocks/SelectionContainerBlock/Scripts/SelectionContainerBlock';
import '../../Components/Blocks/ShortcutsBlock/Scripts/ShortcutsBlock';
import '../../Components/Blocks/VideoBlock/Scripts/VideoBlock';
import '../../Components/Layout/Header/Scripts/Header';
import '../../Components/Layout/Navigation/Scripts/language';
import '../../Components/Layout/Navigation/Scripts/myaimopark';
import '../../Components/Layout/ServiceInformation/Scripts/ServiceInformation';
import '../../Components/Layout/ErrorMessage/Scripts/ErrorMessage';
import '../../Components/Pages/_Shared/Scripts/LandlordAddNewForm';
import '../../Components/Pages/_Shared/Scripts/LandlordPermitForm';
import '../../Components/Pages/_Shared/Scripts/LandlordPermitOverlay';
import '../../Components/Pages/_Shared/Scripts/LogoutTimer';
import '../../Components/Pages/_Shared/Scripts/MyAimoParkConfirm';
import '../../Components/Pages/_Shared/Scripts/MyAimoParkForm';
import '../../Components/Pages/_Shared/Scripts/MyAimoParkLoadMore';
import '../../Components/Pages/_Shared/Scripts/MyAimoParkNavigation';
import '../../Components/Pages/_Shared/Scripts/MyAimoParkOverlay';
import '../../Components/Pages/_Shared/Scripts/MyAimoParkPermitsEditPoNumber';
import '../../Components/Pages/_Shared/Scripts/MyAimoParkVehicleList';
import '../../Components/Pages/_Shared/Scripts/MyAimoParkVehicleListItem';
import '../../Components/Pages/CampaignListPage/Scripts/CampaignListPage';
import '../../Components/Pages/CitiesPage/Scripts/CitiesPage';
import '../../Components/Pages/CityPage/Scripts/CityPage';
import '../../Components/Pages/FacilityPage/Scripts/FacilityLightbox';
import '../../Components/Pages/FacilityPage/Scripts/PmcNotificationList';
import '../../Components/Pages/FacilityPage/Scripts/FacilityProducts';
import '../../Components/Pages/FacilityPage/Scripts/ImageSlider';
import '../../Components/Pages/FacilityPage/Scripts/NearbyFacilities';
import '../../Components/Pages/RequireAccountContentPage/Scripts/RequireAccountContentPage';
import '../../Components/Pages/LandlordAdministratorsPage/Scripts/LandlordAdministratorsPage';
import '../../Components/Pages/LandlordPeopleOrganizationsPage/Scripts/LandlordPeopleOrganizationsFilter';
import '../../Components/Pages/LandlordPeopleOrganizationsPage/Scripts/LandlordPeopleOrganizationsPage';
import '../../Components/Pages/LandlordPermitsPage/Scripts/LandlordPermitsFilter';
import '../../Components/Pages/LandlordPermitsPage/Scripts/LandlordPermitsPage';
import '../../Components/Pages/LandlordStartPage/Scripts/LandlordStartPage';
import '../../Components/Pages/MyAimoParkDigitalPermitsPage/Scripts/MyAimoParkDigitalPermitsPage';
import '../../Components/Pages/MyAimoParkInvoicesPage/Scripts/MyAimoParkInvoicesFilter';
import '../../Components/Pages/MyAimoParkPreliminaryOrderPage/Scripts/MyAimoParkPreliminaryOrderPage';
import '../../Components/Pages/MyAimoParkPrePaidBookingPage/Scripts/MyAimoParkPrePaidBookingPage';
import '../../Components/Pages/MyAimoParkSeasonTicketsPage/Scripts/MyAimoParkSeasonTicketsPage';
import '../../Components/Pages/MyAimoParkSettingsPage/Scripts/MyAimoParkEditSettingsPage';
import '../../Components/Pages/MyAimoParkSettingsPage/Scripts/MyAimoParkSettingsPage';
import '../../Components/Pages/StartPage/Scripts/StartPageSearch';

// MAIN CSS
import '../../Components/Blocks/AppealBlock/Styles/AppealBlock.scss';
import '../../Components/Blocks/CaseContainerBlock/Styles/CaseContainerBlock.scss';
import '../../Components/Blocks/CaseItemBlock/Styles/CaseItemBlock.scss';
import '../../Components/Blocks/CollageContainerBlock/Styles/CollageContainerBlock.scss';
import '../../Components/Blocks/CollageItemBlock/Styles/CollageItemBlock.scss';
import '../../Components/Blocks/ContactBlock/Styles/ContactBlock.scss';
import '../../Components/Blocks/ContactItemBlock/Styles/ContactItemBlock.scss';
import '../../Components/Blocks/CTABlockAP/Styles/CTABlockAP.scss';
import '../../Components/Blocks/ExpandableListContainerBlock/Styles/ExpandableListContainerBlock.scss';
import '../../Components/Blocks/ExpandableListItemBlock/Styles/ExpandableListItemBlock.scss';
import '../../Components/Blocks/ExtendedFactsBlock/Styles/ExtendedFactsBlock.scss';
import '../../Components/Blocks/FacilityInfoBlock/Styles/FacilityInfoBlock.scss';
import '../../Components/Blocks/FacilityUSPBlock/Styles/FacilityUSPBlock.scss';
import '../../Components/Blocks/FactsBlock/Styles/FactsBlock.scss';
import '../../Components/Blocks/GridContainerBlock/Styles/GridContainerBlock.scss';
import '../../Components/Blocks/GridItemBlock/Styles/GridItemBlock.scss';
import '../../Components/Blocks/HeaderAndTextDividerBlock/Styles/HeaderAndTextDividerBlock.scss';
import '../../Components/Blocks/ImageBlock/Styles/ImageBlock.scss';
import '../../Components/Blocks/ImageInTextBlock/Styles/ImageInTextBlock.scss';
import '../../Components/Blocks/LatestNewsBlock/Styles/LatestNewsBlock.scss';
import '../../Components/Blocks/LinkBlock/Styles/LinkBlock.scss';
import '../../Components/Blocks/ListBlock/Styles/ListBlock.scss';
import '../../Components/Blocks/MovingImagesBlock/Styles/MovingImagesBlock.scss';
import '../../Components/Blocks/PresentationContainerBlock/Styles/PresentationContainerBlock.scss';
import '../../Components/Blocks/PresentationItemBlock/Styles/PresentationItemBlock.scss';
import '../../Components/Blocks/ProductContainerBlock/Styles/ProductContainerBlock.scss';
import '../../Components/Blocks/ProductItemBlock/Styles/ProductItemBlock.scss';
import '../../Components/Blocks/PuffBlock/Styles/PuffBlock.scss';
import '../../Components/Blocks/PuffWithLinkBlock/Styles/PuffWithLinkBlock.scss';
import '../../Components/Blocks/QuickContactBlock/Styles/QuickContactBlock.scss';
import '../../Components/Blocks/SelectionContainerBlock/Styles/SelectionContainerBlock.scss';
import '../../Components/Blocks/SelectionItemBlock/Styles/SelectionItemBlock.scss';
import '../../Components/Blocks/ShortcutsBlock/Styles/ShortcutsBlock.scss';
import '../../Components/Blocks/VideoBlock/Styles/VideoBlock.scss';
import '../../Components/Layout/Footer/Styles/footer.scss';
import '../../Components/Layout/Header/Styles/header.scss';
import '../../Components/Layout/Navigation/Styles/navigation.scss';
import '../../Components/Layout/ServiceInformation/Styles/serviceinformation.scss';
import '../../Components/Layout/ErrorMessage/Styles/errormessage.scss';
import '../../Components/Pages/_Shared/Styles/LandlordAddNewForm.scss';
import '../../Components/Pages/_Shared/Styles/LandlordPermitForm.scss';
import '../../Components/Pages/_Shared/Styles/MyAimoParkConfirm.scss';
import '../../Components/Pages/_Shared/Styles/MyAimoParkNavigation.scss';
import '../../Components/Pages/_Shared/Styles/MyAimoParkOverlay.scss';
import '../../Components/Pages/_Shared/Styles/SomethingWentWrong.scss';
import '../../Components/Pages/AboutAimoPage/Styles/AboutAimoPage.scss';
import '../../Components/Pages/BookingFlowPage/Styles/BookingFlowPage.scss';
import '../../Components/Pages/WaitingListFlowPage/Styles/WaitingListFlowPage.scss';
import '../../Components/Pages/CampaignListPage/Styles/CampaignListPage.scss';
import '../../Components/Pages/CampaignPage/Styles/CampaignPage.scss';
import '../../Components/Pages/CitiesPage/Styles/CitiesPage.scss';
import '../../Components/Pages/CityPage/Styles/CityPage.scss';
import '../../Components/Pages/ContentListPage/Styles/ContentListPage.scss';
import '../../Components/Pages/ContentPage/Styles/ContentPage.scss';
import '../../Components/Pages/CustomerSupportPage/Styles/CustomerSupportPage.scss';
import '../../Components/Pages/FacilityPage/Styles/FacilityPage.scss';
import '../../Components/Pages/FacilitySearchPage/Styles/FacilitySearchPage.scss';
import '../../Components/Pages/LandlordAdministratorsPage/Styles/LandlordAdministratorsPage.scss';
import '../../Components/Pages/LandlordPage/Styles/LandlordPage.scss';
import '../../Components/Pages/LandlordPeopleOrganizationsPage/Styles/LandlordPeopleOrganizationsPage.scss';
import '../../Components/Pages/LandlordPeopleOrganizationsPage/Styles/LandlordSinglePersonOrganizationPage.scss';
import '../../Components/Pages/LandlordPermitsPage/Styles/LandlordPermitsPage.scss';
import '../../Components/Pages/LandlordPlacesPage/Styles/LandlordPlacesPage.scss';
import '../../Components/Pages/LandlordPlacesPage/Styles/LandlordSinglePlacePage.scss';
import '../../Components/Pages/MyAimoParkDigitalPermitsPage/Styles/MyAimoParkDigitalPermitsPage.scss';
import '../../Components/Pages/MyAimoParkInvoicesPage/Styles/MyAimoParkInvoicesPage.scss';
import '../../Components/Pages/MyAimoParkPreliminaryOrderPage/Styles/MyAimoParkPreliminaryOrderPage.scss';
import '../../Components/Pages/MyAimoParkPrepaidBookingPage/Styles/MyAimoParkPrepaidBookingPage.scss';
import '../../Components/Pages/MyAimoParkSeasonTicketsPage/Styles/MyAimoParkSeasonTicketsPage.scss';
import '../../Components/Pages/MyAimoParkSettingsPage/Styles/MyAimoParkSettingsPage.scss';
import '../../Components/Pages/MyAimoParkShortTermParkingPage/Styles/MyAimoParkShortTermParkingPage.scss';
import '../../Components/Pages/MyAimoParkStartPage/Styles/MyAimoParkStartPage.scss';
import '../../Components/Pages/MyAimoParkSwitchAccountPage/Styles/MyAimoParkSwitchAccountPage.scss';
import '../../Components/Pages/NotFoundPage/Styles/NotFoundPage.scss';
import '../../Components/Pages/PresentationPage/Styles/PresentationPage.scss';
import '../../Components/Pages/ProductPage/Styles/ProductPage.scss';
import '../../Components/Pages/StartPage/Styles/StartPage.scss';
import '../../Components/Pages/FacilityPage/Styles/PmcNotificationListForm.scss';
import '../../Components/Pages/_Shared/Styles/ConfirmedAnimation.scss';

//POST JS
import './_Shared/form';
import './_Shared/select';
import './_Shared/fileupload';
import './_Shared/post';
